import { Deserializable } from '../deserializable';

export class SecurityQuestionDto implements Deserializable {
  public SecurityQuestionCode: string;
  public Answer: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
